import React from 'react'
import { shallow } from 'enzyme'

import Topic from '../../features/Highlight/Topic'

describe('Topic', () => {
  let wrapper, props, result, instance
  beforeEach(() => {
    props = {
      topic: {
        rid: 1, 
        category: 'guarantor', 
        document: null,
        draft: true,
        explanation: 'Some explanation',
        guarantor: null,
        nextHighlight: {
          rid: 2,
        },
        predefined: true,
        previousHighlight: null,
        topic: 'CBR',
      },
      onCloseClick: jest.fn(),
      onSaveNewTopic: jest.fn(),
      onUpdateExistingTopic: jest.fn(),
      onDeleteTopic: jest.fn(),
      loanId: 123,
      isBankUser: false,
    },
    wrapper = shallow(<Topic {...props} />)
    instance = wrapper.instance()
  })
  it('should set default states', () => {
    expect(wrapper.state('isHovered')).toBeFalsy();
    expect(wrapper.state('isUnsavedModalOpen')).toBeFalsy();
    expect(wrapper.state('editorState')).toEqual('closed');
  })

  describe('#setIsHovered', () => {
    it('should change state', () => {
      instance.setIsHovered(false)
      expect(wrapper.state('isHovered')).toBeFalsy();
      instance.setIsHovered(true)
      expect(wrapper.state('isHovered')).toBeTruthy();
    })
  })
  describe('#setEditorState', () => {
    it('should change editorState to passed value state', () => {
      instance.setEditorState('open')
      expect(wrapper.state('editorState')).toEqual('open');
    })
  })
  describe('#deleteTopic', () => {
    it('should change editorState to passed value state', () => {
      instance.deleteTopic()
      expect(wrapper.state('editorState')).toEqual('closed');
    })
    it('should call onDeleteTopic props method', () => {
      instance.deleteTopic()
      expect(props.onDeleteTopic).toHaveBeenCalledTimes(1)
    })
  })
  describe('#onNoSaveTopic', () => {
    it('should change editorState to passed value state', () => {
      const toggleUnsavedModal = spyOn(instance, 'toggleUnsavedModal')
      instance.onNoSaveTopic()
      expect(toggleUnsavedModal).toHaveBeenCalled()
      expect(wrapper.state('editorState')).toEqual('closed');
    })
    it('should call onCloseClick props method', () => {
      props.topic.rid = null
      instance.onNoSaveTopic()
      expect(props.onCloseClick).toHaveBeenCalledTimes(1)
    })
  })
  describe('#onUnsavedTopic', () => {
    it('should call function', () => {
      const toggleUnsavedModal = spyOn(instance, 'toggleUnsavedModal')
      instance.onUnsavedTopic()
      expect(toggleUnsavedModal).toHaveBeenCalled()
    })
    it('should should set the editorState as closed function', () => {
      instance.onUnsavedTopic()
      expect(wrapper.state('editorState')).toEqual("closed")
    })
    it('should call saveAsDraft or postClick function', () => {
      const onSaveAsDraftClick = spyOn(instance, 'onSaveAsDraftClick')
      const onPostClick = spyOn(instance, 'onPostClick')
      
      instance.onUnsavedTopic()
      expect(onSaveAsDraftClick).toHaveBeenCalledTimes(1)
      wrapper.setState({data : { draft: false}})
      instance.onUnsavedTopic()
      expect(onPostClick).toHaveBeenCalledTimes(1)
    })
  })
  describe('#onCloseClick', () => {
    describe('when text editor content is present', () => {
      it('should call toggleUnsavedModal function', () => {
        const toggleUnsavedModal = spyOn(instance, 'toggleUnsavedModal')
        instance.onCloseClick('tilte', 'content')
        expect(toggleUnsavedModal).toHaveBeenCalled()
      })
    })
    describe('when text editor content is not present', () => {
      it('should call onCloseClick function', () => {
        props.topic.rid = null
        instance.onCloseClick('tilte', '')
        expect(props.onCloseClick).toHaveBeenCalled()
        expect(wrapper.state('editorState')).toEqual('closed')
      })
    })
  })
  describe('#onNewOrUpdateTopic', () => {
    it('should call onUpdateExistingTopic function', () => {
      instance.onNewOrUpdateTopic('tilte')
      expect(props.onUpdateExistingTopic).toHaveBeenCalled()
    })
    it('should call onSaveNewTopic function', () => {
      wrapper.setState({ data: { rid: null } })
      instance.onNewOrUpdateTopic('tilte')
      expect(props.onSaveNewTopic).toHaveBeenCalled()
    })
  })
  describe('#getPropsBasedOnDraft', () => {
    it('should return rid based props', () => {
      const result = instance.getPropsBasedOnDraft(true, 'title', 'contennt', null, null)
      expect(result.rid).toEqual(props.topic.rid)
      expect(result.editorTitle).toEqual('title')
    })
    it('should not return rid based props', () => {
      wrapper.setState({ data: { rid: null } })
      const result = instance.getPropsBasedOnDraft(true, 'title', 'contennt', null, null)
      expect(result.rid).toBeFalsy();
    })
  })
  describe('#onSaveAsDraftClick', () => {
    it('should call onNewOrUpdateTopic function', () => {
      const onNewOrUpdateTopic = spyOn(instance, 'onNewOrUpdateTopic')
      instance.onSaveAsDraftClick('title', 'contennt', null, null)
      expect(onNewOrUpdateTopic).toHaveBeenCalledWith({
        "deleteFiles": null,
        "draft": true,
        "editorContent": "contennt",
        "editorTitle": "title",
        "files": null,
        "rid": 1,
      });
    })
  })
  describe('#onaddAnExplanationClick', () => {
    it('should change editorState to passed value state', () => {
      instance.onaddAnExplanationClick()
      expect(wrapper.state('editorState')).toEqual('open');
      expect(wrapper.state('isEditDraft')).toBeFalsy();
    })
  })
  describe('#onPostClick', () => {
    it('should call onNewOrUpdateTopic function', () => {
      const onNewOrUpdateTopic = spyOn(instance, 'onNewOrUpdateTopic')
      instance.onPostClick('title', 'contennt', null, null)
      expect(onNewOrUpdateTopic).toHaveBeenCalledWith({
        "deleteFiles": null,
        "draft": false,
        "editorContent": "contennt",
        "editorTitle": "title",
        "files": null,
        "rid": 1,
      });
    })
  })
})